import { createFileRoute, useNavigate } from "@tanstack/react-router";
import z from "zod";
import { FullPageLoading } from "@/components/full-page-loading";
import { useAuth } from "@/context/auth-context";
import { useEffectOnce } from "@/hooks/use-effect-once";
import { log } from "@/lib/log";

const loginSchema = z.object({
  code: z.string().min(1).catch(""),
});

export const Route = createFileRoute("/login")({
  validateSearch: (search) => {
    return loginSchema.parse(search);
  },
  component: LoginRoute,
});

function LoginRoute() {
  const { code } = Route.useSearch();
  const navigate = useNavigate();
  const auth = useAuth();

  useEffectOnce(
    (didRun) => {
      didRun();
      const performLogin = async () => {
        if (code) {
          await auth.login(code).catch(() => {
            log.error("Login failed with code", code);
          });
        }
        navigate({ to: "/" });
      };
      performLogin();
    },
    [code, auth.login, navigate],
  );

  return <FullPageLoading text="Logging in..." />;
}
